module.exports = __webpack_public_path__ + "static/img/1.7d8639d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/2/1/1.png
// module id = +pMy
// module chunks = 0